import { render, staticRenderFns } from "./ZHRecord.vue?vue&type=template&id=135f5780&scoped=true&"
import script from "./ZHRecord.vue?vue&type=script&lang=js&"
export * from "./ZHRecord.vue?vue&type=script&lang=js&"
import style0 from "./ZHRecord.vue?vue&type=style&index=0&id=135f5780&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135f5780",
  null
  
)

export default component.exports